// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-7b57572e]{width:calc(100% - 29px);margin:2px 0 10px 0}.fa-solid[data-v-7b57572e]{position:absolute;right:16px;top:11px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
